import moment from "moment";
import { GETREQUEST } from "./ServiceRequest";
import {generateInvoicePdf} from "../Pdfs/invoice"
import { generateProductCreditPdf } from "../Pdfs/ProductCredit";
import { generateCrateCreditPdf } from "../Pdfs/CrateCredit";

export const getCrateCreditPreview = async (user, id) => {
    if (!id) {
        return;
    }

    const crateCreditURL = `${process.env.REACT_APP_API_URL}/get-crate-credit/${id}`;

    try {
        const crateResponse = await GETREQUEST(crateCreditURL, user.jwtToken, false)
        if (!crateResponse.data) {
            return;
        }

        const crateData = crateResponse.data.credit;
        const containersData = crateResponse.data.containers;

        const crList = containersData.map(item => ({
            label: item.TypeInCode,
            value: item.ContainerID,
            ...item
        }));

        const updatedCrateDetails = crateData?.tblCrateCreditDetails?.filter(creditItem =>
            creditItem.Qty !== '' && creditItem.ContainerID !== '' && creditItem.CrateReturnValue !== ''
        ).map(creditItem => ({
            ...creditItem,
            CrateCreditAmt: creditItem.CrateCreditAmt ? parseFloat(creditItem.CrateCreditAmt).toFixed(2) : 0
        })) || [];

        const previewData = {
            CNID: id,
            ReturnDate: moment(crateData?.CNDate).format('YYYY-MM-DD'),
            ReferenceNo: crateData?.CNReference,
            tblCustomer: crateData?.tblCustomer,
            crates: crList,
            creditDetails: updatedCrateDetails
        };

        generateCrateCreditPdf(previewData);

    } catch (error) {
        console.error("Error fetching crate credit preview:", error);
    }
};

export const getProductCreditPreview = async (user, id) => {
    if (!id) {
        return;
    }

    const productCreditURL = process.env.REACT_APP_API_URL + `/get-produce-credit/${id} `;

    try {
        const productsCreditResponse = await GETREQUEST(productCreditURL, user.jwtToken, false)
        if (!productsCreditResponse.data) {
            return;
        }

        const productData = productsCreditResponse.data.credit;
        const unitsData = productsCreditResponse.data.units;
        const products = productsCreditResponse.data.products;

        const units = unitsData.map(item => ({
            label: item.UnitName,
            value: item.UnitID,
            ...item
        }));

        const updatedProdDetails = productData?.tblProdCreditDetails?.filter(creditItem =>
            creditItem.Qty !== '' && creditItem.ContainerID !== '' && creditItem.CrateReturnValue !== ''
        ).map(creditItem => ({
            ...creditItem,
            ProdCreditAmt: creditItem.ProdCreditAmt ? parseFloat(creditItem.ProdCreditAmt).toFixed(2) : 0,
            ProdCreditGSTAmt: creditItem.ProdCreditGSTAmt ? parseFloat(creditItem.ProdCreditGSTAmt).toFixed(2) : 0,
        })) || [];

        let previewData = {
            CNID: id,
            ReturnDate: moment(productData?.CNDate).format('YYYY-MM-DD'),
            ReferenceNo: productData?.CNReference,
            tblCustomer: productData?.tblCustomer,
            products,
            units,
            creditDetails: updatedProdDetails
        }
       generateProductCreditPdf(previewData);

    } catch (error) {
        console.error("Error fetching product credit preview:", error);
    }
};

export const getInvoicePreview = async (user, id) => {
    if (!id) {
        return;
    }

    const InvoiceURL = `${process.env.REACT_APP_API_URL}/get-invoice/${id}`;
    try {
        const invoiceResponse = await GETREQUEST(InvoiceURL, user.jwtToken, false)
        if (!invoiceResponse.data) {
            return;
        }

        await generateInvoicePdf(invoiceResponse.data);
    } catch (error) {
        console.error("Error fetching Invoice preview:", error);
    }

}